import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

export const ReturnAddress = ({ returnOrder }) => {
  const address = {
    Contact: returnOrder.contact,
    Email: returnOrder.email,
    Phone: returnOrder.mobileNo,
    Name: returnOrder.name,
    "Address 1": returnOrder.address,
    "Address 2": returnOrder.address2,
    City: returnOrder.city,
    County: returnOrder.county,
    Postcode: returnOrder.postCode,
    Country: returnOrder.country,
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Address
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        {Object.entries(address).map(([key, value], i) => (
          <Grid
            key={key}
            size={{
              xs: 2,
              sm: 4,
              md: 4,
            }}
          >
            <TextField
              size="small"
              fullWidth
              id={`${key}-input`}
              label={key}
              value={value || ""}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Grid>
        ))}
        <Grid
          sx={{ display: "flex", alignItems: "center" }}
          size={{
            xs: 2,
            sm: 4,
            md: 4,
          }}
        >
          <FormControlLabel
            disabled
            control={<Switch checked={!!returnOrder.homeaddress} />}
            label="Residential"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
